import * as yup from 'yup';
import { requiredImageFromCMSSchema } from '../schemas';

export const schema = yup
  .object({
    image: requiredImageFromCMSSchema,
    title: yup.string().required(),
    body: yup.string().required(),
    addPupButtonText: yup.string().required(),
    addPupButtonVariant: yup.string().required(),
    contactSupportButtonText: yup.string().required(),
    contactSupportButtonVariant: yup.string().required(),
  })
  .transform(value => ({
    image: value.image,
    title: value.title,
    body: value.body,
    addPupButtonText: value.add_pup_button_text,
    addPupButtonVariant: value.add_pup_button_variant,
    contactSupportButtonText: value.contact_support_button_text,
    contactSupportButtonVariant: value.contact_support_button_variant,
  }));
